import { z } from 'zod';

import { BaseFlowBlockSchema, BlockType } from '../base/baseSchema.js';

export const CreatePatientOrderConfigSchema = z.object({
  payload: z.string(),
});

export type CreatePatientOrderConfig = z.infer<typeof CreatePatientOrderConfigSchema>;

export const CreatePatientOrderBlockSchema = BaseFlowBlockSchema.extend({
  type: z.literal(BlockType.CreatePatientOrder),
  config: CreatePatientOrderConfigSchema,
});

export type CreatePatientOrderBlock = z.infer<typeof CreatePatientOrderBlockSchema>;
